/**
 * Fetch a user by ID from Stream Chat and map the data using a callback.
 * @param {object} chatClient - The Stream Chat client instance.
 * @param {string} userId - The user ID to fetch.
 * @param {function} mapUserDataCb - Callback to map user data (user, null, chatClient).
 * @returns {Promise<object|undefined>} The mapped user object or undefined if not found.
 */
export async function fetchUserById(chatClient, userId, mapUserDataCb) {
  const response = await chatClient.queryUsers({ id: { $eq: userId } });
  const user = response?.users[0];

  return user ? mapUserDataCb(user, null, chatClient) : undefined;
}